import Service from './Service';

class NyilatkozatokService extends Service {
    getKgfbNyilatkozatok(id) {
        return this.get(`kgfb/kgfb-declarations/?id=${id}`);
    }

    saveKgfbNyilatkozat(id, nyilatkozatok) {
        return this.post(`kgfb/kgfb-declarations/?id=${id}`, nyilatkozatok);
    }

    getCompanyDeclarations(companyId, modozat) {
        return this.get('common/company-declaration?', {
            company_id: companyId,
            modozat,
        });
    }
}

export default new NyilatkozatokService('/');
